import { POSIcon } from '@publicisgroupe/p-os-components';
import { useCallback, useState } from 'react';
import moment from 'moment';

import { Dictionary, Notification } from 'types/types';
import './NewsFeedTile.less';

interface NewsFeedTileProps {
  data: Notification;
  handleNotificationSidebar: () => void;
  handleNotificationOnClose: () => void;
  handleNotificationClick: (context: Dictionary<string>) => void;
}

export const NewsFeedTile = ({
  data,
  handleNotificationOnClose,
  handleNotificationSidebar,
  handleNotificationClick,
}: NewsFeedTileProps) => {
  const [onHover, setOnHover] = useState<boolean>(false);

  const handleNotificationOnClick = useCallback(() => {
    handleNotificationSidebar();
    handleNotificationClick(data.context);
  }, [data.context, handleNotificationClick, handleNotificationSidebar]);

  return (
    <>
      {data && (
        <div
          className="news-feed"
          onMouseEnter={() => setOnHover(true)}
          onMouseLeave={() => setOnHover(false)}
        >
          <div className="news-feed-action">
            {!onHover && <p className="news-feed-timestamp">{moment(data.createdAt).fromNow()}</p>}
            {onHover && (
              <POSIcon
                icon="close"
                className="small close-icon"
                onClick={() => handleNotificationOnClose()}
              />
            )}
          </div>
          <div onClick={() => handleNotificationOnClick()}>
            <div className="news-feed-tile">
              <p className="news-feed-subheader">{data.title}</p>
            </div>
            <p className="news-feed-content">{data.message}</p>
          </div>
        </div>
      )}
    </>
  );
};
